import styled from "styled-components";

export const LibraryStyle = styled.div`
    .ms-FocusZone{
        //display: none;
        //background: teal;
    }
    .ms-List
    {
        margin: 5px;
    }
    .ms-List-cell
    {
        display: inline-block;
    }
    .ms-List-page{
        grid-template-columns: 140px 140px 170px;
        grid-gap: 28px;
        display: grid;
    }
    .item
    {
        cursor: pointer;
        display: flex;
        width:135px;
        height:115px;
        margin: 5px;
        text-align: center;
        background-color: white;
        padding: 0px;
        position: relative;
        border: 1px solid #ccc;
        align-items: center;
        justify-content: center;
        &.active, &.selected{
            border: 5px solid #2B7092;
            box-sizing: border-box;
        }
        h5{
            margin: 0px;
            position: absolute;
            bottom: 0px;
            text-align: center;
            width: 100%;
            left: 0px;
            background: rgba(0,0,0,.1);
            padding: 5px 0;
        }
        i{
            font-size: 70px;
            color: #2B7092;
        }
        &.image
        {
            img{
                max-height:100px;
                max-width: 100px;
            }
            h5{
                display: none;
            }
        }
           
    }
`;

export const FolderInfo = styled.div`
    margin-left: 10px;
    position: absolute;
    top: 40px;
    right: 25px;
`;

export const ContentStyle = styled.div`
    display:flex;
`;

export const MediaItemStyle = styled.div`
    flex-grow: 1;
    background: white;
    padding: 20px;
    box-sizing: border-box;

    display: grid;
    grid-template-areas: "head head" "main main";
    margin-top: -102px;
    grid-auto-rows: max-content;
    grid-column-gap: 20px;

    img
    {
        width:100%;
        border: 1px solid black;
        grid-area: head;
    }
    > * {
        margin-bottom: 15px;
        clear: both;
    }

    > label
    {        
        float: left;
        padding-left: 2px;
    }
    > div{
        width: 96%;
        clear: none;
        &:nth-child(even){
            float: left;
        }
        &:nth-child(odd){
            float: right;
        }

        &:after{
            content: "";
            display: block;
            padding-top: 23px;
        }
        > label:first-child
        {
            width: 50%;
            /*display: inline-block;*/
            float: left;
        }

        > div{
            float: right;
            > span{
                padding: 5px 0px;
            }
            > label{
                float: left;
                font-weight: bold;
                &:first-child{
                    margin-right: 3px;
                }
            }


        }
    }
    .ms-TextField
    {
        clear: both;
    }
    position: relative;
    &:hover{
        button{
            opacity: 1;
        }
    }

    .media-delete-button
    {
        position: absolute;
        right: 18px;
        top: 20px;
        background: red;
        transition: all .4s linear;
        border: none;
        opacity: 0;
        .ms-Button-label{
            color: white;
            font-size: 11px;
        }
        &:hover{
            background: darkred;
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/media/style.ts